export const AUTH_STATES = {
    registration: 'registration',
    login: 'login',
    restore: 'restore',
}

export default {
    state: () => ({
        authState: AUTH_STATES.login
    }),


    mutations: {
        ['auth/setAuthState']: (state, payload) => {
            state.authState = payload
        }
    }
}